import { useContext, useState } from 'react';
import { Navigate } from 'react-router-dom';
import AppContext from '../../context';
import Data from '../../repository';

function SuperAdminLogin() {
	const context = useContext(AppContext);
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	if (context.user?.superAdmin) return <Navigate to="/super-admin/dashboard" />;

	const onSubmit = async (event) => {
		event.preventDefault();
		setLoading(true);
		setError(null);

		try {
			const result = await Data.superAdminLogin(email, password);
			localStorage.setItem("token", result.data.token);
			window.location.href = "/super-admin/dashboard";
		} catch (err) {
			setPassword('');
			setError(err.response?.data?.message || "Unable to login.");
			setLoading(false);
		}
	};

	return (
		<div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: '#f5f6f8', padding: '20px' }}>
			<div style={{ width: '100%', maxWidth: '420px', background: '#fff', borderRadius: '8px', padding: '28px', border: '1px solid #e9ecef' }}>
				<h1 style={{ margin: 0, fontSize: '24px' }}>Super Admin Login</h1>
				<p style={{ marginTop: '8px', color: '#6b7280' }}>Use super admin credentials only.</p>

				{error ? (
					<div style={{ background: '#fde8e8', color: '#b91c1c', border: '1px solid #fecaca', borderRadius: '6px', padding: '10px 12px', marginTop: '14px' }}>
						{error}
					</div>
				) : null}

				<form onSubmit={onSubmit} style={{ display: 'grid', gap: '12px', marginTop: '18px' }}>
					<input
						type="email"
						placeholder="Email"
						value={email}
						onChange={(event) => setEmail(event.target.value)}
						required
					/>
					<input
						type="password"
						placeholder="Password"
						value={password}
						onChange={(event) => setPassword(event.target.value)}
						required
					/>
					<button type="submit" className="btn btnPrimary" disabled={loading}>
						{loading ? "Logging in..." : "Login"}
					</button>
				</form>
			</div>
		</div>
	);
}

export default SuperAdminLogin;
